import { getNamespacedBy } from '@/store/utils'

export const actionTypes = {
  FETCH_HEALTH_PLANS: 'fetchHealthPlans'
}

export const globalActions = getNamespacedBy('healthPlan', actionTypes)
